// KontrolaPracovnikovCard.jsx — karta na domove „Kto pre nás pracuje“ (Mirko 13. 9. 2026: „každý pondelok office kontrolovali,
// kto pre nás pracuje a či sa stav do piatku nezmenil — je to veľmi dôležité“; termín „pondelok ihneď ráno“).
// Stav dáva GET /api/kontrola-pracovnikov/stav. Pondelok od rána bez kontroly = červená bliká (bez pípania), piatok od rána
// bez potvrdenia = červená bliká; cez víkend bez blikania. Hotovo = zelená s menom a časom. Klik otvorí stránku kontroly.
import React, { useEffect, useState } from 'react'
import { fetchAuth } from '../auth/fetchAuth.js'

export function useKontrolaStav(interval = 60000) {
  const [d, setD] = useState(null)
  useEffect(() => {
    let alive = true
    const load = () => fetchAuth('/api/kontrola-pracovnikov/stav').then(r => r.ok ? r.json() : null).then(x => { if (alive) setD(x) }).catch(() => {})
    load(); const id = setInterval(load, interval)
    return () => { alive = false; clearInterval(id) }
  }, [interval])
  return d
}

const KEYFRAMES = `@keyframes kamirBlikKP { 0%,100% { background:#dc2626 } 50% { background:#7f1d1d } }`
const hhmm = (x) => (x ? String(x).replace('T', ' ').slice(11, 16) : '')
const first = (n) => String(n || '').split(' ')[0]

export function KontrolaPracovnikovCard({ onOpen, cardStyle }) {
  const d = useKontrolaStav()
  if (!d || d.visible === false) return null
  const blink = !!(d.overdue && !d.weekend)
  let bg = '#16a34a', color = '#fff', big = 'OK', sub = '', title = 'Kto pre nás pracuje'
  const vyst = d.nahlasene_vystupy ? ` · nahlásené výstupy: ${d.nahlasene_vystupy}` : ''
  if (d.due === 'pondelok') {
    if (d.overdue) { bg = undefined; big = 'KONTROLA CHÝBA'; sub = `pondelková kontrola pracovníkov (${d.active_count}). Klikni a urob ju.` }
    else { bg = '#f59e0b'; big = 'PONDELOK'; sub = `ráno skontroluj, kto pre nás pracuje (${d.active_count})` }
  } else if (d.due === 'piatok') {
    if (d.overdue) { bg = undefined; big = 'PIATOK CHÝBA'; sub = 'zmenil sa stav od pondelka? Klikni a potvrď.' }
    else { bg = '#f59e0b'; big = 'PIATOK'; sub = 'potvrď, či sa stav od pondelka nezmenil' }
  } else {
    const poT = d.po ? `pondelok ${first(d.po.checked_by)} ${hhmm(d.po.checked_at)}` : 'pondelok —'
    const piT = d.pi ? (d.pi.bez_zmeny ? 'piatok bez zmeny' : `piatok ${d.pi.pocet_nepracuje ? d.pi.pocet_nepracuje + ' zmien' : 'OK'}`) : (d.dow < 5 ? 'piatok sa pýtame v piatok' : '')
    if (d.weekend) { bg = '#6b7280'; big = 'víkend'; sub = d.po ? [poT, piT].filter(Boolean).join(' · ') : 'v pondelok ráno: kontrola, kto pre nás pracuje' }
    else { big = d.po && d.po.pocet_nepracuje ? `OK · ${d.po.pocet_nepracuje} výstup` : 'OK'; sub = [poT, piT].filter(Boolean).join(' · ') }
  }
  return (
    <div onClick={onOpen} title="Týždenná kontrola: kto pre nás pracuje (pondelok ráno) a či sa stav do piatku nezmenil. Klik otvorí zoznam."
      style={{ ...(cardStyle || {}), cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: 2, color, background: bg, animation: blink ? 'kamirBlikKP 1s infinite' : 'none' }}>
      <style>{KEYFRAMES}</style>
      <div style={{ fontSize: 13, fontWeight: 600, opacity: .92 }}>{title}</div>
      <div style={{ fontSize: big.length > 12 ? 20 : 28, fontWeight: 700, lineHeight: 1.15 }}>{big}</div>
      <div style={{ fontSize: 13, opacity: .92, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{sub}{vyst}</div>
    </div>
  )
}
